/* eslint-disable max-len */
/* eslint-disable @next/next/no-img-element */
import {Form, Checkbox} from 'antd';
import useCommon from '@utils/hooks/common';
import styles from './styles';
import {useRef, useState} from 'react';
import {useRouter} from 'next/router';
import GradientButton from '@components/GradientButton';
import PopupContainer from '../PopupContainer';
import {CustomModalSheetProps} from '@components/CustomModalSheet';

const DisclaimerModal = (props: CustomModalSheetProps) => {
  const {classes, t, user, system, theme} = useCommon({
    withTranslation: ['userProfile', 'home', 'referral'],
    withStyles: styles,
    observers: ['user', 'system'],
  });

  const {isModalSheetOpen, onModalSheetClose} = props;

  const [form] = Form.useForm();

  const router = useRouter();

  return (
    <PopupContainer
      // mobileModalProps={{snapPoints: [450]}}
      sheetDetent="content-height"
      visible={isModalSheetOpen}
      closable={false}
      onCancel={() => {}}
      title={t('disclaimer')}
      desktopModalProps={{bodyStyle: {height: '500px'}}}
    >
      <div style={{padding: '0px 10px'}}>
        <Form
          form={form}
          onFinish={values => {
            console.log('@@ onFinish, values', values);
            window.localStorage.setItem(`hasAgreedDisclaimer`, 'true');
            window.localStorage.setItem('dontShowIPBlockAgain', 'true');
            // window.localStorage.setItem(`dontShowIPBlockAgain_${user.getPlayerId()}`, 'true');
            // setIsDisclaimerVisible(false);
            system?.dismissModalSheet();
            // user?.refreshPlayerInfo()

            if (values.dontShowDisclaimerAgain) {
              window.localStorage.setItem(`dontShowDisclaimerAgain_${user.getPlayerId()}`, 'true');
            }
          }}
        >
          <div style={{width: '100%', display: 'flex', justifyContent: 'center'}}>
            <img
              src="/images-mobile/disclaimer.svg"
              alt="disclaimer"
              style={{width: 75, height: 75}}
            />
          </div>
          <p>{t('disclaimer:message')}</p>
          <p style={{color: '#c50000'}}>{t('disclaimer:countryList')}</p>

          <Form.Item
            name="agreeDisclaimer"
            valuePropName="checked"
            rules={[
              {
                validator(rule, value, callback) {
                  if (!value) {
                    return Promise.reject(t('disclaimer:required_message'));
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <Checkbox style={{color: theme.secondaryTextColor}}>
              {t('disclaimer:checkbox_message')}
            </Checkbox>
          </Form.Item>

          <Form.Item name="dontShowDisclaimerAgain" valuePropName="checked">
            <Checkbox style={{color: theme.secondaryTextColor}}>
              {t('common:dont_show_again')}
            </Checkbox>
          </Form.Item>
        </Form>

        <div style={{borderTop: '1px solid rgba(255, 255, 255, 0.10)'}}>
          <GradientButton style={{height: 50, borderTop: '0.5px grey'}} onClick={form.submit}>
            {t('common:confirm')}
          </GradientButton>
        </div>
      </div>
    </PopupContainer>
  );
};

export default DisclaimerModal;
